import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Popover, PopoverBody } from "reactstrap";
import { logoutAction } from "store/slices/auth/authSlices";
import ChangePassWordModal from "./changePassModal";

const PopoverComponent = ({ content, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);

  const { jwt } = useSelector((state) => state.auth);

  useEffect(() => {
    window.addEventListener("click", () => {
      setIsOpen(false);
    });
  }, []);

  const toggleModal = () => {
    setModal(!modal);
  };

  const cerrarSesion = () => {
    dispatch(logoutAction());
    navigate("/");
    localStorage.removeItem("open");
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <div
        id="popover-button"
        onClick={toggle}
        className={`d-flex align-items-center justify-content-end  pointer ${
          !isOpen ? "poppover" : "border"
        } px-2 py-0 rounded`}
      >
        <span className="mdi mdi-account-circle account mr-2"></span>
        <p className="text-right ">{user?.email}</p>
        <span className="mdi mdi-arrow-down-drop-circle ml-2"></span>
      </div>
      <div>
        <Popover
          placement="bottom"
          isOpen={isOpen}
          target="popover-button"
          toggle={toggle}
        >
          <PopoverBody>
            <div>
              <div className=" p-2">
                <p
                  onClick={() => {
                    toggleModal();
                    toggle();
                  }}
                  className="pointer"
                >
                  Cambiar Contraseña
                </p>
              </div>
              <hr className="m-0" />
              <div className=" p-2">
                <p onClick={cerrarSesion} className="text-right pointer">
                  Cerrar Sesión
                  <span className="mdi mdi-logout-variant text-dark ml-1"></span>
                </p>
              </div>
            </div>
          </PopoverBody>
        </Popover>
      </div>
      <ChangePassWordModal
        modal={modal}
        toggleModal={toggleModal}
        idUser={user?.email}
      ></ChangePassWordModal>
    </div>
  );
};

export default PopoverComponent;
